import {observer} from 'mobx-react-lite'
import React from 'react'
import {
  TwHistoryItemContainer,
  TwHistoryUserContainer,
  TwHistoryDate,
  TwHistoryDateContainer,
  TwHistoryUser
} from './containers'
import {useTaskDescription} from './task-description-store'
import {Time} from 'yougile-util'
import {UserAvatarV2} from '@components/common/user-avatar-v2/user-avatar-v2'
import {UsersMap} from './hooks/use-get-prepared-users'
import {UserProxy} from '@extensions/proxies/user-proxy'
import {DataObjectId} from 'yougile-model'
import {Lang} from 'yougile-lang'

type HistoryItemProps = {
  userId: DataObjectId
  prevUserId?: string
  date: number
  usersMap: UsersMap
}

export const TaskDescriptionHistoryItem = observer(
  (props: HistoryItemProps) => {
    const {userId, date, prevUserId, usersMap} = props
    const [state, store] = useTaskDescription()

    const type = !prevUserId ? 'first' : 'middle'
    const shouldBeShowed = prevUserId !== userId

    const notFoundUser: UserProxy = {
      userId,
      userName: Lang.msg.userIsNotFound,
      userShortName: Lang.msg.userIsNotFound,
      userImage: '',
      userBackgroundColor: '',
      userInfo: '',
      userStatus: 'offline',
      userEmail: '',
      deleted: false,
      userIsAdmin: false,
      userIsInDoNotDisturbMode: false
    }

    const user = usersMap[userId] || notFoundUser

    const onSelectItem = () => {
      store.selectHistoryItem(date)
    }
    const selected = state.selectedHistoryAt === date

    return (
      <TwHistoryItemContainer>
        {shouldBeShowed && (
          <TwHistoryUserContainer $type={type}>
            <UserAvatarV2 {...user} size={20} hideStatus={true} />
            <TwHistoryUser>{user.userName}</TwHistoryUser>
          </TwHistoryUserContainer>
        )}
        <TwHistoryDateContainer onClick={onSelectItem} $selected={selected}>
          <TwHistoryDate $selected={selected}>
            {Time.formatDateTime(date, false, false, false, true, true)}
          </TwHistoryDate>
        </TwHistoryDateContainer>
      </TwHistoryItemContainer>
    )
  }
)
